import { createStore } from "@/stores/createStore";
import type { ChainState } from "@/stores/chain/types";

const model: ChainState = {
  status: "idle",
  chain: [],
  forExperienceId: null,
  token: null,
};

export const chainStore = {
  ...createStore(model),
  getChain: () => model.chain,
  getStatus: () => model.status,
};
